<template>
  <section>
    <div
      id="myChart"
      ref="myChart"
      :style="{ height: boxHeight + 'rem' }"
    ></div>
  </section>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      myChart: null,
      dataValue: [],
      yName: [],
      mountData: "",
      updateData: "",
      fullDiv: {
        top: "28%",
        left: "10%",
      },
    };
  },
  props: {
    boxHeight: {
      default: 18,
      type: Number,
    },
    showtime: {
      default: false,
      type: Boolean,
    },
    showLegend: {
      default: false,
      type: Boolean,
    },
    coordinateName: {
      default: "",
      type: String,
    },
  },

  components: {},

  mounted() {
    let that = this;
    window.onresize = function () {
      that.myChart.resize();
    };
    if (window.outerWidth <= 1920) {
      this.fullDiv = {
        left: "5%",
        right: "5%",
        bottom: "1%",
        top: "30%",
        containLabel: true,
      };
    }
  },
  watch: {},
  methods: {
    upDateChart(content) {
      // console.log("content", content);
      this.myChart.setOption({
        series: (() => {
          let list = [];
          content.seriseList.map((li, l_index) => {
            let _color = li.color ? li.color : this.getColor();
            console.log("li", li);
            let item = {
              type: li.type,
              data: li.data,
              name: li.name,
              label: li.label,
              smooth: true,
              showSymbol: li.label ? true : false,
              lineStyle: {
                color: _color,
                type: li.lineType ? li.lineType : "solid",
              },
              emphasis: {
                focus: "series",
              },
              areaStyle: {
                opacity: li.areaOpacity ? 1 : 0,
                color: li.areaColor,
              },
              itemStyle: {
                color: _color,
              },
              // yAxisIndex: li.yAxisIndex ? li.yAxisIndex : 0,
            };
            list.push(item);
          });
          // console.log("list", list);
          return list;
        })(),
        legend: content.tooltip,
      });
    },
    myEcharts(data) {
      let echarts = require("echarts");
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.myChart);
      this.setChartData(data);
      // 指定图表的配置项和数据
    },
    setChartData(data) {
    //   console.log("data", data);
      let option = {
        // legend: {
        //   top: "bottom",
        // },
        // toolbox: {
        //   show: true,
        //   feature: {
        //     mark: { show: true },
        //     dataView: { show: true, readOnly: false },
        //     restore: { show: true },
        //     saveAsImage: { show: true },
        //   },
        // },
        label: {
          // show: false, //不显示坐标轴上的文字
          show: true,
          color: "#fff",
          fontSize: this.$common.setFontSize(0.92),
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ['30%', '60%'],
            // center: ["50%", "50%"],
            // roseType: 'area',
            // itemStyle: {
            //   borderRadius: 8
            // },
            data: data.seriesData,
            // [
            //   { value: 40, name: "rose 1" },
            //   { value: 38, name: "rose 2" },
            //   { value: 32, name: "rose 3" },
            //   { value: 30, name: "rose 4" },
            //   { value: 28, name: "rose 5" },
            //   { value: 26, name: "rose 6" },
            //   { value: 22, name: "rose 7" },
            //   { value: 18, name: "rose 8" },
            // ]
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    },
    setFontSize(val) {
      // console.log("val", val);
      const baseSize = 15;
      const scale = document.documentElement.clientWidth / 1920;
      const nowSize = baseSize * Math.min(scale, 2);
      // console.log("val * nowSize", val, nowSize);
      return val * nowSize;
    },
    getColor() {
      return (
        "#" +
        ("00000" + ((Math.random() * 0x1000000) << 0).toString(16)).substr(-6)
      );
    },
    destroyedChart() {
      if (this.myChart) {
        this.myChart.dispose();
      }
    },
  },
  destroyed() {
    // this.bus.$off("updateData");
  },
};
</script>
<style lang='scss' scoped>
</style>